import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
  },
  iconWrapper: {
    maxWidth: 32,
    marginRight: 16,
    '& svg': {
      display: 'block',
      width: 32,
      height: 32,
      color: theme.color.greys[80],
    },
  },
  title: {
    marginBottom: 4,
  },
}), { name: 'InfoNote' });
